import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import figure1 from "../../../../assets/images/blog9-1.png";
import figure2 from "../../../../assets/images/blog9-2.png";
import figure21 from "../../../../assets/images/blog9-2.1.png";
import figure23 from "../../../../assets/images/blog9-23.png";
import figure3 from "../../../../assets/images/blog9-3.png";
import figure4 from "../../../../assets/images/blog9-41.png";
import figure42 from "../../../../assets/images/blog9-42.png";
import figure5 from "../../../../assets/images/blog9-5.png";
import figure52 from "../../../../assets/images/blog9-53.png";
import figure6 from "../../../../assets/images/blog9-61.png";
import figure7 from "../../../../assets/images/blog9-7.png";
import figure8 from "../../../../assets/images/blog9-8.png";
const Blog9 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – March 10, 2025</h2>
      </div>
      <div className="blogContentnew">
        <div className="subHeader">
          <p className="highlightedBoldText">Introduction: Market on the Edge</p>
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p>
                Big moves are happening across global markets, and traders need to stay sharp. The U.S. economy has run into a wall—whether by design or sheer momentum, that’s the debate. Meanwhile,
                Europe is firing up its economic engines with massive defense and infrastructure spending, while China’s trade data signals deeper economic distress.
              </p>
              <p>
                With a potential U.S. government shutdown looming, the Bank of Canada set to cut rates, and inflation data on deck, we’re in for a volatile week. Sentiment is at extreme levels, with
                hedge funds unloading stocks while retail traders scramble for downside protection. But as history tells us, these moments often mark inflection points.
              </p>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <p className="highlightedBoldText">Key Market Themes </p>

          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">U.S. Growth Stalls, Recession Debate Heats Up</p>
              <p>
                The U.S. economy is flashing red, with Goldman Sachs cutting 2025 GDP growth forecasts to 1.7% (Q4/Q4) from 2.2%. The Atlanta Fed’s GDPNow model has plunged into negative territory,
                now forecasting a <span className="highlightedText"> -2.4% GDP contraction</span> for Q1. This is a major shift from previous expectations and could force the Fed’s hand sooner than
                expected.
              </p>
              <p>
                JPMorgan strategists suggest that <span className="highlightedText">90% of the current selloff is behind us,</span> but with U.S. equities closing below their 200-day moving averages,
                the next two weeks are crucial. Will economic weakness be the catalyst for rate cuts, or are we entering a deeper slowdown?
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={figure1}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure1)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv">
              <p className="highlightedText_header">European Markets Surge – Can the Rally Last?</p>
              <p>
                While U.S. markets falter, European equities continue to outperform. Capital flows are shifting into
                <span className="highlightedText"> defense, infrastructure, and industrials </span> following a European Summit that signaled record government spending. Germany has taken the lead,
                unleashing
                <span className="highlightedText"> €500bn in industrial stimulus,</span> plus an
                <span className="highlightedText"> €800bn defense package— </span>, the largest since reunification.
              </p>
              <p>
                But will this spending spree lead to a <span className="highlightedText"> true Euro-bond issuance,</span> or simply ignite another inflationary spiral? For now, investors are piling
                into European equities, with the <span className="highlightedText"> DAX outperforming the S&P 500 by over 5% YTD.</span>
              </p>
            </div>
            <div className="imageWrapper">
              <div className="relatedImg">
                <img
                  src={figure2}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(figure2)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={figure21}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(figure21)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={figure23}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(figure23)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">China’s Economy in Distress, Stimulus Incoming?</p>

              <p>
                China’s trade data and inflation numbers paint a grim picture.
                <span className="highlightedText"> Exports remain weak, imports are collapsing, and deflation is deepening. </span> while The consumer price index (CPI) fell at its sharpest pace in 13
                months, and producer price deflation has now extended for a 30th straight month.
              </p>
              <p>
                With Beijing now committing to a <span className="highlightedText"> 4% fiscal deficit target,</span> expectations for stimulus are growing. The{" "}
                <span className="highlightedText"> Chinese tech sector has become a major battleground in the AI race,</span> with Beijing doubling down on semiconductor support. If China unleashes
                broad-based stimulus, expect a <span className="highlightedText"> risk-on rally in metals, commodities, and tech.</span>
              </p>
              <div className="imageWrapper">
                <div className="relatedImg">
                  <img
                    src={figure3}
                    alt=""
                    style={{objectFit: "cover"}}
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(figure3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <p className="highlightedBoldText">Technical & Sentiment Analysis</p>

          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv">
              <p className="highlightedText_header">NASDAQ 100 Crashes Through 200-Day Moving Average</p>
              <p>
                A brutal -10% drop took the NASDAQ through its 200DMA, triggering widespread panic selling. However,
                <span className="highlightedText"> Broadcom’s blowout earnings </span> helped the index recover off Friday’s lows, raising the question—was this the bottom?
              </p>
              <p>
                Historically, when <span className="highlightedText">sentiment reaches extreme bearish levels,</span>a reversal is often near. But the
                <span className="highlightedText">next two weeks are critical—</span>
                —if NASDAQ falls another 3.5% below its 200DMA, the downtrend could accelerate hard.
              </p>
            </div>
            <div className="imageWrapper">
              <div className="relatedImg">
                <img
                  src={figure4}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(figure4)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={figure42}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(figure42)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv">
              <p className="highlightedText_header">Hedge Funds and Retail Investors Dump Stocks</p>
              <p>
                Hedge funds have been <span className="highlightedText">dumping stocks at the fastest pace in years,</span> while retail investors have rushed into{" "}
                <span className="highlightedText">record-high put buying.</span> This extreme level of downside protection is often a<span className="highlightedText">contrarian bullish signal—</span>{" "}
                but is it different this time?
              </p>
            </div>
            <div className="imageWrapper">
              <div className="relatedImg">
                <img
                  src={figure5}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(figure5)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={figure52}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(figure52)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">SPX & Dow Holding on for Dear Life</p>
              <p>
                The S&P 500 and Dow Jones are teetering on the edge. While NASDAQ has already hit a -10% correction,
                <span className="highlightedText">SPX and Dow have not yet breached their key support levels.</span> If these indices break below their 200DMAs, further downside could be swift.
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={figure6}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure6)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText">Defense stocks surged</h2>
                  <p>on massive European spending, but inflation concerns triggered some profit-taking.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Gold rallied hard,</h2>
                  <p>with inflows into safe havens accelerating.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText">U.S. payrolls disappointed</h2>
                  <p>with the unemployment rate ticking up to 4.1%</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> German bond yields jumped 40bps,</h2>
                  <p>marking their sharpest move since 1990.</p>
                </li>
              </ul>
            </div>
            <div className="relatedImg">
              <img
                src={figure7}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure7)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Week Ahead: Key Events & Earnings</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText">Monday:</h2>
                  <p>CNY CPI (Deflation Alarm), NY Fed Inflation Expectations</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Tuesday:</h2>
                  <p>U.S. JOLTS, Oil EIA Short-Term Outlook, Volkswagen Earnings</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText">Wednesday:</h2>
                  <p>U.S. CPI, Bank of Canada Rate Decision, Metals tariffs, Adobe & Inditex Earnings</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Thursday:</h2>
                  <p>ECB Speakers, U.S. PPI & Initial Claims</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Friday:</h2>
                  <p>U.S. Michigan Consumer Confidence, U.K. GDP</p>
                </li>
              </ul>
            </div>
            <div className="relatedImg">
              <img
                src={figure8}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(figure8)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Actionable Takeaways</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText">Europe is outperforming –</h2>
                  <p> Keep an eye on defense and infrastructure plays.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> China stimulus is incoming –</h2>
                  <p> Watch for a rally in metals, commodities, and tech.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText">NASDAQ near a bottom? –</h2>
                  <p> Extreme bearish sentiment often signals a reversal.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> SPX 200DMA is key –</h2>
                  <p> A break below could trigger another leg lower</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper row_reverse ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Key Trades to Watch</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <h2 className="pointersText">Long European defense stocks –</h2>
                  <p> The spending spree is real</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Short U.S. dollar (DXY) –</h2>
                  <p> The Fed is increasingly likely to cut rates.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText">Long Gold (XAU/USD) –</h2>
                  <p> Safe-haven demand remains strong.</p>
                </li>
                <li className="themesPointer">
                  <h2 className="pointersText"> Short U.S. regional banks (KRE ETF) –</h2>
                  <p> The economic slowdown is starting to show cracks in the financial sector.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <p className="highlightedBoldText">Final Thoughts</p>
              <p>
                The market is at a crossroads. Extreme fear and technical breakdowns suggest further downside risk, but{" "}
                <span className="highlightedText"> capitulation signals and record hedge fund selling hint at a potential bottom.</span> Keep an eye on key technical levels and capital flows—March
                could be the pivot month that defines 2025.
              </p>
              <p>Trade smart, and stay nimble!</p>
            </div>
          </div>
        </div>

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1W5VKTJ7a3zR581eqv1Njy9spJLMdGKXA0dSEmkl2Itk/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog9;
